export const USER_LOGIN = "USER_LOGIN";
export const USER_LOGOUT = "USER_LOGOUT";
export const USER_UPDATE = "USER_UPDATE";

export const TOGGLE_DRAWER = "TOGGLE_DRAWER";